import { Navigate } from 'react-router-dom';

/**
 * SessionExtendRedirect - Redirect component for /extend-session route
 *
 * Handles the fallback URL from gw-sdk's MarketplaceSDK when session extend fails.
 * The SDK redirects to `/extend-session?sessionId=...` which doesn't exist in the router.
 * This component redirects to the correct route: `/personal/sessions?action=extend&sessionId=...`
 *
 * Originally added in GW-7917, removed in GW-8286 (on the assumption all consumers would
 * upgrade the SDK). Restored in GW-9839 because 3rd-party apps cannot be forced to upgrade,
 * so an un-upgraded SDK's extend-fallback URL would otherwise 404.
 *
 * @example
 * // In App.tsx router:
 * <Route path="/extend-session" element={<SessionExtendRedirect />} />
 */
export const SessionExtendRedirect = () => {
  // Read sessionId from query params
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get('sessionId');

  // If sessionId is present and non-empty, redirect with action=extend
  if (sessionId && sessionId.trim() !== '') {
    return <Navigate to={`/personal/sessions?action=extend&sessionId=${sessionId}`} replace />;
  }

  // Graceful fallback: redirect to sessions list without action param
  return <Navigate to="/personal/sessions" replace />;
};
